import { render, staticRenderFns } from "./DuplicateProgram.vue?vue&type=template&id=467d4209&"
import script from "./DuplicateProgram.vue?vue&type=script&lang=js&"
export * from "./DuplicateProgram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports